import { RootState } from 'app/store';

export const selectIsDyslexiaOn = (state: RootState) => state.accessibility.isDyslexiaOn;
export const selectIsAmblyopiaOn = (state: RootState) => state.accessibility.isAmblyopiaOn;
export const selectIsUnderlineOn = (state: RootState) => state.accessibility.isUnderlineOn;

export const selectFontSizeLevel = (state: RootState) => state.accessibility.fontSizeLevel;
export const selectLineSpacingLevel = (state: RootState) => state.accessibility.lineSpacingLevel;
export const selectWordSpacingLevel = (state: RootState) => state.accessibility.wordSpacingLevel;